<template>
    <div class="full-window q-mt-lg q-mx-lg">
        <div style="display: flex; justify-content: space-between;">
        <h1 class="title-h1">Existing Schedule For This Campaign</h1>
        <!-- <button style="background-color: rgb(16,38,137); border: 2px solid rgb(16,38,137); border-radius: 5px; padding-left: 10px; padding-right: 10px;"><a href="https://report-dump-uniqin.s3.us-west-2.amazonaws.com/analysis/analysis.xlsx" style="color: white;" @click="download">Download last 15days analysis</a>
        </button> -->
        </div>
        <div class="schedule-table q-my-md">
            <table>
                <thead>
                    <tr>
                        <th style="width: 3%"></th>
                        <th>Rule Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Date of creation</th>
                        <th>Status</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, index) in sortedTableData">
                        <tr>
                            <td style="
                      text-align: center;
                      font-weight: bold;
                      font-family: monospace;
                    " @click="displaytable(index)" class="icontext"></td>
                            <!-- <td><i class="qfi qfi-minus-square"></i></td> -->
                            <td>{{ getEmailBasedCampaignName(item,index) }}</td>
                            <td>{{ item.start_date }}</td>
                            <td>{{ item.end_date }}</td>
                            <td>{{ item.insert_timestamp }}</td>
                            <td>
                                <!--Toggle button starts-->
                                <div>
                                    <label class="toggle-button-label">
                                        <input class="toggle-button" type="checkbox" v-model="item.is_enable" :disabled="isSubmitDisabled"
                                            :true-value="true" :false-value="false" @click="toggleButton(item)" />
                                        <span class="toggle-button-field" :style="item.is_enable == true
                                            ? { backgroundColor: 'green' }
                                            : { backgroundColor: '#ccc' }
                                            "></span>
                                        <span class="toggle-button-text" @click="trackingStatus(item.is_enable,item.scheduler_name)">
                                            {{ item.is_enable == true ? "On" : "Off" }}
                                        </span>
                                    </label>
                                </div>
                                <!-- Toggle button-->
                                <!-- <q-btn
                  :color="item.state === 'ENABLED' ? 'primary' : 'red'"
                  :label="item.state === 'ENABLED' ? 'Enable' : 'Disable'"
                  class="statebtn"
                  @click="buttonFunc(item.state)"
                /> -->
                            </td>
                            <td>
                                <q-btn :style="item.is_enable == true
                                    ? 'pointer-events:auto'
                                    : 'pointer-events:none;opacity:0.5;'" label="Edit" id="editButton"
                                    @click="editFunc(item,item.scheduler_name)" />
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div>
                <q-dialog v-model="show1">
                    <q-card style="width: 900px; max-width: 80vw;">
                        <q-card-section v-for="(item, index) in editDataTable" :key="index" id="dialogueBox" class="q-mx-md q-my-md">
                            <div class="row">
                                <div class="col-5" style="pointer-events: none;opacity:0.9">
                                    <q-input v-model="item.camp_name" label="Campaign Name"  class="remove-valid-styles"></q-input>
                                </div>
                                <div class="col q-ml-lg"   :style="{ pointerEvents: item.is_enable === true ? 'auto' : 'none' }" >
                                    <q-input v-model="item.budget_setting.new_value" type="number" label="Budget"  class="remove-valid-styles"></q-input>
                                </div>
                                <div class="col q-ml-lg"  :style="{ pointerEvents: item.is_enable === true ? 'auto' : 'none' }" >
                                    
    
                                    <!-- <q-input v-model="item.time_to_occur"  label="Time"  class="remove-valid-styles"></q-input> -->
                                        <label style="font-size: small; font-weight: 500; color: rgb(158, 154, 154);margin-bottom: 0; padding-bottom: 0;">Time</label>
                                        <div style="display: flex; align-items: flex-end; height: 0px;">
                                            <q-select v-model="item.time_to_occur"
      :options="filteredTimeOptions"
      option-label="label"
      option-value="value"
      :option-disable="shouldDisableOption"
      emit-value
      dense
      class="small-q-select"
    />
                                       </div>
                                      

    
                                        
                                    
                                </div>
                                <div class="col q-ml-sm">
                                    <div class="row q-mt-sm " style=" color: grey;
  font-size: 12px;
  line-height: 20px;
  font-weight: 500;
  margin-bottom: 4px;
  transition: color 0.15s cubic-bezier(0.4, 0, 0.2, 1), transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);">Status</div>
                                    <div class="col q-mt-sm q-ml-sm ">
                                        <input class="custom-checkbox" type="checkbox" v-model="item.is_enable"
                                            :true-value="true" :false-value="false" />
                                    </div>
                                </div>
                            </div>
                        </q-card-section>
                        <q-card-actions align="right">
                            <q-btn label="Cancel" @click="cancel" />
                            <q-btn label="Save" color="primary" @click="save(editDataTable)" />
                        </q-card-actions>
                    </q-card>
                </q-dialog>
            </div>
        </div>
        <div>
            <h5 class="title-createcampaign">To create campaign scheduler follow the below steps</h5>
        </div>
        <div class="row level q-mt-md" :style="{
            backgroundColor: StepNumber === 1 ? '#102689' : 'white',
            color: StepNumber === 1 ? 'white' : 'black'
        }" @click="() => { StepNumber = 1; level1Completed = false; }">
            <div class=" col">
                <h6><span class="steps q-mr-md " :style="{ backgroundColor: StepNumber === 1 ? 'white' : '#C6CDD1' }"> Step
                        1
                    </span>Initial Steps of Dayparting
                </h6>
            </div>
            <div class="col completed q-mr-md" v-if="level1Completed">
                <h6>Completed</h6>
            </div>
        </div>
        <div class="second q-mb-lg" v-if="StepNumber === 1">
            <div class="value">
                <div class="rulename q-mb-md">
                    <p>Rule Name</p>
                    <q-input outlined v-model="ruleName" class="remove-valid-styles"></q-input>
                </div>
                <div class="initialSteps" style="width:700px;" id="initialSteps">
                    <div class="row">
                        <div class="col-2">Start date:</div>
                        <div class="col q-mr-xl">
                            <q-input outlined dense v-model="startDate" :rules="['date']" class="remove-valid-styles">
                                <template v-slot:prepend>
                                    <q-icon name="event" class="cursor-pointer">
                                        <q-popup-proxy ref="qStartDateProxy" cover transition-show="scale"
                                            transition-hide="scale">
                                            <q-date v-model="startDate" :options="options" @input="closeStartDateCalendar">
                                            </q-date>
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>
                            </q-input>
                        </div>
                        <div class="col-2">End date:</div>
                        <div class="col">
                            <q-input outlined dense v-model="endDate" :rules="['date']" class="remove-valid-styles">
                                <template v-slot:prepend>
                                    <q-icon name="event" class="cursor-pointer">
                                        <q-popup-proxy ref="qDateProxy" cover transition-show="scale"
                                            transition-hide="scale">
                                            <q-date v-model="endDate" :options="options" @input="closeCalendar">
                                            </q-date>
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>
                            </q-input>
                        </div>
                    </div>
                </div>
                <p style="color:red" v-if="error1"> *Please fill Rule Name and Date Columns</p>
                <p style="color:red" v-if="error2"> *Valid Date Range: Start Date should be earlier than End Date</p>
            </div>
            <div class="next-1">
                <q-btn label="Next" @click="nextButton1"></q-btn>
            </div>
        </div>
        <div class="row level q-mt-md" :style="{
            backgroundColor: StepNumber === 2 ? '#102689' : 'white',
            color: StepNumber === 2 ? 'white' : 'black'
        }" @click="() => { StepNumber = 2; level2Completed = false; }">
            <div class=" col">
                <h6><span class="steps q-mr-md" :style="{ backgroundColor: StepNumber === 2 ? 'white' : '#C6CDD1' }"> Step 2
                    </span>Level of Dayparting
                </h6>
            </div>
            <div class="col">
                <div class="col completed q-mr-md" v-if="level2Completed">
                    <h6>Completed</h6>
                </div>
            </div>
        </div>
        <div class="second" v-if="StepNumber == 2">
            <div class="levelofdayparting">
                <div class="row">
                    <p class="q-mb-md"> <strong>Apply day Pating automation for Campaign level</strong></p>
                    <div class="radio col">
                        <q-btn @click="manuallySelect" class="q-ml-lg manually">Select Campaign</q-btn>
                    </div>
                    <div class="search-container col " v-if="secondTableVisible">
                        <input v-model="searchQuery" placeholder="Search Campaign" class="search-input" />
                        <i class="fas fa-search search-icon"></i>
                    </div>
                </div>
            </div>
            <div class="second-table q-my-sm" v-if="secondTableVisible">
                <p style="color:red">*You can't add a campaign if it exist in other enabled rule</p>
                <table>
                    <thead>
                        <tr>
                            <th style="width: 3%"></th>
                            <th> <input id="select-all-checkbox" class="custom-checkbox" type="checkbox" v-model="selectAll"
                                    @change="selectAllCheckboxes" /></th>
                            <th>Campaign Name</th>
                            <th>Budget</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>State</th>
                            <th>Type</th>
                            <th>Targeting Type</th>
                            <th>Existing Rule</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template>
                            <tr v-for="(item, index) in filteredTable" :key="index">
                                <td style="
                      text-align: center;
                      font-weight: bold;
                      font-family: monospace;
                    " @click="displaytable(index)" class="icontext"></td>
                                <!-- <td><i class="qfi qfi-minus-square"></i></td> -->
                                <td>
                                    <input :id="'checkbox-' + index" class="custom-checkbox" type="checkbox"
                                        :checked="item.selected" @change="handleCheckboxChange(index)"
                                        :style="{ pointerEvents: item.exist_rules === '' ? 'auto' : 'none' }" />
                                    <label :for="'checkbox-' + index"></label>
                                </td>
                                <td>{{ getadschedulecampaign(item,index) }}</td>
                                <td>{{ item.budget }}</td>
                                <td>{{ item.startDate }}</td>
                                <td>{{ item.endDate }}</td>
                                <td>{{ item.state }}</td>
                                <td>{{ item.Type }}</td>
                                <td>{{ item.targetingType }}</td>
                                <td>{{ item.exist_rules }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <p style="color:red" v-if="error2"> *Please select at least one campaign </p>
            <div class="next-2">
                <q-btn @click="nextButton2">Next</q-btn>
            </div>
        </div>
        <div class="level q-mt-md" :style="{
            backgroundColor: StepNumber === 3 ? '#102689' : 'white',
            color: StepNumber === 3 ? 'white' : 'black'
        }" @click="StepNumber = 3">
            <h6><span class="steps q-mr-md" :style="{ backgroundColor: StepNumber === 3 ? 'white' : '#C6CDD1' }"> Step 3
                </span>Setting up Dayparting
            </h6>
        </div>
        <div class="second q-mb-lg" v-if="StepNumber == 3">
            <div>
                <p v-if="budgetError" style="color:red"> *Select time </p>
                <p v-if="budgetError1" style="color:red"> *Invalid budget range specified. Please ensure that the budget is
                    between 50 and 5000. </p>
                <div class="daypartying row" v-for="(row, index) in count" :key="index">
                    <div class="col-3">
                        <p>Select time</p>
                        <q-btn-dropdown class="q-mb-lg" :label="timeFormatDisplay[index]"
                            style="color: black;font-size:15px;margin-top: 13px;">
                            <q-list>
                                <q-item clickable v-for="item in timeFormat" :key="item" v-close-popup
                                    @click="timeFormatFunction(item, index)">
                                    <q-item-section>
                                        <q-item-label>{{ item }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </q-btn-dropdown>
                    </div>
                    <div class="col">
                        <p>Select budget for this hour</p>
                        <div class="row set">
                            <q-input v-model="newBudget[index]" @click="newBuget(index)" type="number"
                                class="remove-valid-styles"></q-input> <q-btn @click="setTime(index)"
                                class=" manually q-mt-lg q-ml-sm' : isTickSet(index), 'disabled': !isTickSet(index) }"
                                :disabled="!isTickSet(index)">Set</q-btn><font-awesome-icon
                                v-if="isTickSetTick(index) == true" class=" q-ml-md" :icon="['fas', 'circle-check']"
                                style="font-size:26px;margin-top:30px" :class="{ 'green': isTickSet(index) }" />
                            <q-btn icon="delete" style="margin-top:25px;color:red" @click="removeItem(index)"
                                class="deleteicon q-ml-md q-m" flat></q-btn>
                        </div>
                    </div>
                </div>
            </div>
            <p @click="incrementCount" v-if="count < 6" class="add-row q-mt-md">+ Add more items</p>
        </div>
        <div class="next-1 q-mt-xl">
            <q-btn label="Submit" :disabled="isSubmitDisabled" :style="disableSubmit ? 'pointer-events:none;opacity:0.5;' : 'pointer-events:auto'"
                @click="suBmit"></q-btn>
        </div>
    </div>
</template>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

#dialogueBox {
    border: 2px solid #102689 !important;
    color: Black !important;
}
.small-q-select {
  font-size: 12px; /* Adjust the font size as needed */
  height:5px;
}

.q-card {
    box-shadow: none !important;
    border-radius: 0px;
    vertical-align: top;
    background: white !important;
    position: relative;
}

.green {
    color: darkgreen;
}

body {
    font-family: "Montserrat", sans-serif;
}

.full-window h1 {
    font: normal normal bold 25px/30px Montserrat;
}

.title-h1,
.title-createcampaign {
    font: normal normal bold 18px/32px Montserrat;
    letter-spacing: 0px;
    color: #000000;
    text-transform: capitalize;
    opacity: 1;
}

.full-window table {
    border-collapse: collapse;
    border-radius: 1em;
    width: 100%;
}

.full-window table td {
    padding: 6px 10px;
}

.full-window table tr:hover {
    background-color: #ddd;
}

.full-window table th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #e7ebf0;
    color: black;
}

.schedule-table {
    max-height: 300px;
    overflow-y: auto;
}

.second-table {
    max-height: 300px;
    overflow-y: auto;
}

.schedule-table thead,
.second-table thead {
    position: sticky;
    top: 0;
    z-index: 1;
    opacity: 1;
    background: #C6CDD1 0% 0% no-repeat padding-box;
    border-radius: 10px 10px 0px 0px;
}

.schedule-table tbody,
.second-table tbody {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 0px 0px 10px 10px;
    opacity: 1;
}

.schedule-table th,
.second-table th {
    position: sticky;
    top: 0;
}

.steps {
    background-color: #C6CDD1;
    border-radius: 10px;
    padding: 1px;
    padding-right: 8px;
    padding-left: 8px;
    margin-left: 20px;
    color: #696969 !important;
}

.level {
    background-color: #FFFFFF;
    box-shadow: 1px 2px 8px 3px rgb(142 135 135);
    padding: 5px;
    cursor: pointer;
    font: normal normal 600 16px/18px Montserrat;
    /* border-radius: 5px 5px 0px 0px; */
}

.second {
    border: 1px solid #102689;
    padding: 25px;
    background-color: #FFFFFF;
    margin-top: 0px !important;
    padding-bottom: 35px;
}

.rulename {
    width: 700px;
}

.rulename .q-field__control,
.rulename .initialSteps .q-field__control {
    height: 40px;
}

.value {
    position: relative;
}

.next-1 .q-btn,
.next-2 .q-btn {
    background: #102689 0% 0% no-repeat padding-box;
}

.next-1,
.next-2 {
    justify-content: end;
    align-content: flex-end;
    display: flex;
    opacity: 1;
    color: white;
    padding-right: 10px;
    padding-left: 10px;
    font: normal normal 600 14px/15px Montserrat;
    border-radius: 5px;
}

.completed {
    font-size: 0px !important;
    align-items: center;
    justify-content: end;
    display: flex;
    color: green
}

.completed h6 {
    font-size: 15px !important;
    font-weight: 600;
}

.levelofdayparting {
    position: relative;
}

.manually {
    background: #102689 0% 0% no-repeat padding-box;
    color: white;
}

.set {
    height: 24px;
    border-radius: 5px;
}

.add-row {
    color: #102689;
    cursor: pointer;
}

#table-checkbox .q-checkbox__inner--indet .q-checkbox__indet {
    transform: none !important;
    display: none !important;
    /* transition: transform 0.22s cubic-bezier(0, 0, 0.2, 1) 0ms; */
}

#table-checkbox .q-checkbox__indet {
    fill: white !important;
}

/* .q-checkbox__inner {
  font-size: 10px !important;
  width: 10px !important;
  min-width: 0px !important;
  height: 10px !important;
} */
.toggle-button-label {
    display: inline-block;
    position: relative;
    cursor: pointer;
    user-select: none;
    width: 60px;
    height: 30px;
}

.toggle-button {
    display: none;
}

.toggle-button-field {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 15px;
}

.toggle-button-field:before {
    position: absolute;
    content: "";
    width: 26px;
    height: 26px;
    top: 2px;
    left: 2px;
    border-radius: 50%;
    background-color: #fff;
    transition: transform 0.2s ease;
}

.toggle-button:checked+.toggle-button-field:before {
    transform: translateX(30px);
}

.toggle-button-text {
    position: absolute;
    top: 18%;
    transform: translateX(110%);
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    color: white;
    transition: transform 0.2s ease;
}

.toggle-button:checked+.toggle-button-field~.toggle-button-text {
    transform: translateX(4px);
}

#editButton {
    background: #0F2587 0% 0% no-repeat padding-box;
    border-radius: 5px;
    text-align: left;
    font: normal normal 600 14px/15px Montserrat;
    letter-spacing: 0px;
    color: #FFFFFF;
}

.custom-checkbox {
    transform: scale(1.5);
    /* Increase the size of the checkbox */
    /* Add any other desired custom styles */
}

.search-container {
    position: relative;
    align-items: end;
    justify-content: end;
    display: flex;
}

.search-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-bottom: 1px solid #ccc !important;
    border-radius: 5px;
    font-size: 14px;
    width: 200px;
}

.search-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    font-size: 18px;
    color: #999;
}

.remove-valid-styles::v-deep .q-field__native,
.remove-valid-styles /deep/ .q-field__native {
    /* Override the default :valid styles with your desired styles */
    background-color: transparent;
    /* Add any other styles you want to remove or customize */
}
</style>
<script>
export default {
    data() {
        return {
            api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
            tabledata: [],
            count: 1,
            timeFormat: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
            availableTimes: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
            timeFormatDisplay: ["", "", "", ""],
            StepNumber: 1,
            secondTable: [],
            secondTableVisible: false,
            campaignData: [],
            campaign: {
                campaign_id: 123,
                time_to_occur: 0,
                campaign_type: 0,
                budget_setting: {
                    new_value: 0
                },
                day_of_week_enabled: { 'value': 'all' }
            },
            searchQuery: '',
            selectedItems: [],
            newBudget: ["50", "50", "50", "50"],
            ruleName: "",
            startDate: "",
            endDate: "",
            level1Completed: false,
            level2Completed: false,
            error1: false,
            temp_date: "",
            error2: false,
            tick: [],
            manualCampaign: false,
            tickEnabled: [true, false, false, false],
            budgetError: false,
            budgetError1: false,
            editColumn: false,
            show1: false,
            editDataTable: [],
            sample:0,
            selectAll: false, // Tracks the "Select All" checkbox state
            selectedItems: [], // Array to hold selected items
            items: [/* your data array */],
            deleteIcon: [],
            disableSubmit: false,
            item: {
        is_enable: true,
        
      },
    //   hourOptions: Array.from({ length: 24 }, (_, i) => ({ label: i.toString(), value: i.toString() })),
    //   minuteOptions: [{ label: '00', value: '00' }], // Only one option for minutes
    //   hour:0,
    //   minute:'00',
      selectedTime: null,
      timeOptions: [],
        }
    },
    watch: {
        selectedTime(newVal) {
      console.log('Selected time:', newVal);
    },
        
        searchQuery(newQuery, oldQuery) {
            // Check if the length of the search query is less than the previous value
            if (newQuery.length < oldQuery.length) {
                this.selectAll = false; // Uncheck the "Select All" checkbox
            }
        },
    },
    created() {
        var currentUrl = window.location.href;
        var path = window.location.pathname;
        this.$q.loading.show({
            message: "Authenticating please wait...",
        });
        if (this.$cookies.isKey("login_authentication")) {
            let encryptedText = this.$cookies.get("login_authentication");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: :00", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$store.dispatch("setPathName", "/amazonadoptimization/adschedule");
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else if (this.$cookies.isKey("login_authentication1")) {
            let encryptedText = this.$cookies.get("login_authentication1");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: :00", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else if (this.$cookies.isKey("login_authentication2")) {
            let encryptedText = this.$cookies.get("login_authentication2");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: :00", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$store.dispatch("setPathName", "/amazonadoptimization/adschedule");
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else {
            this.$q.loading.hide();
            this.$router.push({
                name: "NotAuthenticated",
            });
            return;
        }
    },
    mounted() {
        this.$q.loading.show({
            message: 'Loading...'
        });
        this.date()
        this.firstTableCall()
        this.generateTimeOptions();
    },
    computed: {
        filteredTimeOptions() {
    return this.timeOptions.filter(option => option.value.split(':')[1] === '00');
  },
  isSubmitDisabled() {
      // Check if the email is 'support@uniqin.ai'
      const email =  this.$store.state.credentials['attributes']['email']
      
      return email === 'support@uniqin.ai';
    },
        hourOptions() {
      return Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
    },
    minuteOptions() {
      return ['00', '15', '30', '45'];
    },
        isTickSetTick() {
            return (index) => {
                return this.tick[index] === true; // Check if the value at the specified index is true
            };
        },
        filteredTable() {
            return this.secondTable.filter(item =>
                item.campaignName.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
        sortedTableData() {
      const onItems = this.tabledata.filter(item => item.is_enable === true);
      const offItems = this.tabledata.filter(item => item.is_enable === false);
      return onItems.concat(offItems);
    },
    },
    methods: {
        download(){
    this.$mixpanel.track('Downloaded', {
    info: `User downloaded Last 15 days analysis`,
    });

        },
        trackingStatus(status,rulename){
            this.$mixpanel.track('Adschedular/Status',{
                info:`User Selected status as ${status} for this RuleName : ${rulename}`
            })
        },
        getEmailBasedCampaignName(item,index) {
        const email = this.$store.state.credentials['attributes']['email'];
        if (email === 'support@uniqin.ai') {
          return `keyword ${index + 1}`;
        }
        return item.scheduler_name;
    },
    getadschedulecampaign(item,index){
        const email = this.$store.state.credentials['attributes']['email'];
        if (email === 'support@uniqin.ai') {
          return `Campaign ${index + 1}`;
        }
        return item.campaignName;

    },
        firstTableCall() {
            this.level2Completed = false;
            this.selectedItems = [];
            this.$q.loading.show({
                message: 'Loading...'
            });
            var productsURL = this.api_url + "/amazon-ad/get_existing_ad_schedulers";
            this.$http
                .post(productsURL, this.Backendcall())
                .then((response) => {
                    this.tabledata = response.data;
                    console.log("console",this.tabledata)
                    this.$forceUpdate();
                })
            var productsURL1 = this.api_url + "/amazon-ad/get_campaigns_for_scheduler_selection";
            this.$http
                .post(productsURL1, this.Backendcall())
                .then((response) => {
                    this.secondTable = response.data;
                    this.level2Completed = false;
                    this.initializeItems();
                    this.$forceUpdate();
                    this.$q.loading.hide();
                }).catch(() => {
                    this.$q.loading.hide();
                });
        },
        initializeItems() {
            // Initialize the 'selected' property for each item in the 'items' array
            this.items.forEach(item => {
                this.$set(item, 'selected', false);
            });
        },
        closeCalendar() {
            this.$refs.qDateProxy.hide();
        },
        closeStartDateCalendar() {
            this.$refs.qStartDateProxy.hide();
        },
        removeItem(index) {
            this.campaignData = this.campaignData.filter((campaign) => campaign.time_to_occur !== this.timeFormatDisplay[index]);
            this.timeFormatDisplay.splice(index, 1);
            var timesToRemove = this.timeFormatDisplay;
            this.timeFormat = this.availableTimes.filter(function (time) {
                return !timesToRemove.includes(time);
            });
            this.$forceUpdate();
            // Remove the item at the specified index from the array or perform other necessary actions
            this.newBudget.splice(index, 1);
            this.tick.splice(index, 1)
            this.deleteIcon.splice(index, 1);
            if (index > 0) {
                this.tickEnabled.splice(index, 1);
            }
            if (this.count > 1) {
                this.count--
            }
            if (this.tick[index - 1] == true) {
                this.tickEnabled[index] = true;
            }
            this.$forceUpdate();
            // Perform other necessary actions
            // You may need to update other related data properties accordingly
        },
        selectAllCheckboxes() {
            // Update the selected state of all checkboxes based on the "Select All" checkbox
            if (this.selectAll === true) {
                this.filteredTable.forEach(item => {
                    if (item.exist_rules === "") {
                        item.selected = true;
                        if (!this.selectedItems.includes(item)) {
                            this.selectedItems.push(item);
                        }
                    }
                });
            } else {
                this.filteredTable.forEach(item => {
                    item.selected = false;
                });
                this.selectedItems = [];
            }
        },
        handleCheckboxChange(index) {
            // Update the state of the clicked checkbox
            this.filteredTable[index].selected = !this.filteredTable[index].selected;
            // Update the array of selected items
            if (this.filteredTable[index].selected && this.filteredTable[index].exist_rules === "") {
                // Add the selected item to the array
                this.selectedItems.push(this.filteredTable[index]);
            } else {
                // Remove the unselected item from the selectedItems array
                this.selectedItems = this.selectedItems.filter(item => item !== this.filteredTable[index]);
            }
            // Update the state of the "Select All" checkbox based on selected checkboxes
            if (this.selectedItems.length === this.filteredTable.filter(item => item.exist_rules === "").length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },
        toggleButton(item) {
            this.selectedItems = [];
            this.level2Completed = false;
            if (item.is_enable == true) {
                var toggleValue = "off"
            }
            else {
                var toggleValue = "on"
            }
            var toggleValueURL = this.api_url + "/amazon-ad/change_scheduler_status";
            this.$http
                .post(toggleValueURL, this.toggleBackend(toggleValue, item))
                .then((response) => {
                    this.$q.loading.show({
                        message: 'Loading...'
                    });
                    if (response.data == "success") {
                        this.firstTableCall()
                        this.$q.notify({
                            type: 'positive',
                            message: "status changed successfully",
                        })
                        this.searchQuery = ''
                        this.selectAll = false
                    }
                    else {
                        this.$q.loading.hide();
                        this.$q.notify({
                            type: 'negative',
                            message: "Status not saved",
                        })
                    }
                }).catch(() => {
                    this.$q.loading.hide();
                });
        },
        toggleBackend(toggleValue, item) {
            return [{
                ad_sch_rule_id: item.ad_sch_rule_id.toString(),
                new_status: toggleValue
            }]
        },
        date() {
            var date = new Date();
            var dd = String(date.getDate()).padStart(2, '0');
            var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = date.getFullYear();
            this.today_date = yyyy + '/' + mm + '/' + dd;
            this.temp_date = this.today_date;
            this.options(date)
        },
        selectCampaign() {
            this.selectedItems = []
            this.manualCampaign = true
        },
        options(date) {
            return date >= this.temp_date;
        },
        manuallySelect() {
            this.$mixpanel.track('User Selected Campaign in Adschedular',{
                info : 'user selected select campaign'
            });
            this.secondTableVisible = true;
        },
        Backendcall() {
            return [
                {
                    org_id: this.$org_id.label.toString(),
                },
            ];
        },
        incrementCount() {
            if (this.count < 6) {
                this.count++
                if (this.tick[this.count - 2] == true) {
                    this.tickEnabled[this.count - 1] = true
                }
            }
            else {
                this.count = this.count
            }
        },
        timeFormatFunction(item, value) {
            this.timeFormatDisplay[value] = item
            var timesToRemove = this.timeFormatDisplay;
            this.timeFormat = this.availableTimes.filter(function (time) {
                return !timesToRemove.includes(time);
            });
            this.tick[value] = ""
        },
        newBuget(index) {
            this.tick[index] = ""
        },
        setTime(index) {
            if (this.timeFormatDisplay[index] == "" || this.timeFormatDisplay[index] == null || this.timeFormatDisplay[index] == undefined) {
                this.budgetError = true;
            }
            else if (parseInt(this.newBudget[index]) < 50 || parseInt(this.newBudget[index]) > 5000 || this.newBudget[index].length === 0 || this.newBudget[index] == null || this.newBudget[index] == undefined) {
                this.budgetError = false;
                this.budgetError1 = true;
            }
            else {
                this.budgetError = false;
                this.budgetError1 = false;
                this.tick[index] = false;
                this.tick[index] = true
                this.deleteIcon[index] = true;
                if (this.tick[index] == true) {
                    this.tickEnabled[index + 1] = true;
                    this.$forceUpdate();
                }
                this.$forceUpdate();
            }
        },
        submitData() {
            const trueCount = this.tick.reduce((count, value) => {
                return count + (value === true ? 1 : 0);
            }, 0);
            for (var i = 0; i < this.selectedItems.length; i++) {
                for (var j = 0; j < trueCount; j++) {
                    const newCampaign = {
                        campaign_id: this.selectedItems[i].campaignID,
                        time_to_occur: this.timeFormatDisplay[j],
                        campaign_type: this.selectedItems[i].Type,
                        budget_setting: {
                            new_value: this.newBudget[j]
                        },
                        day_of_week_enabled: { value: 'all' },
                        campaign_name: this.selectedItems[i].campaignName
                    };
                    // const dataIndex = i + index * this.selectedItems.length;
                    // if (this.campaignData.length > dataIndex) {
                    //     // Replace the data at the specified index with the new campaign
                    //     this.campaignData.splice(dataIndex, 1, newCampaign);
                    // } else {
                    // Add the new campaign to the end of the array
                    this.campaignData.push(newCampaign);
                    // }
                }
            }
            return [
                {
                    org_id: this.$org_id.label.toString(),
                    scheduler_name: this.ruleName,
                    start_date: this.startDate,
                    end_date: this.endDate,
                    camp_dtls: this.campaignData,
                },
            ];
        },
        editBackend(item) {
            return [
                {
                    ad_sch_rule_id: item.ad_sch_rule_id.toString()
                }
            ]
        },
        editFunc(item,rulename) {
            this.$mixpanel.track('Adschedular/Edit',{
                info : `user In Edit operation for this Rulename : ${rulename}`
            })
            this.$q.loading.show({
                message: ''
            }); 
            var productsURL = this.api_url + "/amazon-ad/get_campaigns_in_ad_scheduler";
            this.$http
                .post(productsURL, this.editBackend(item))
                .then((response) => {
                    this.editDataTable = response.data;
                    console.log("popup",this.editDataTable)
                    this.editDataTable.sort((a, b) => {
                        if (a.camp_name === b.camp_name) {
                        // If campaign names are the same, sort by time
                        return a.time_to_occur.localeCompare(b.time_to_occur);
                        } else {
                        // Sort by campaign name
                        return a.camp_name.localeCompare(b.camp_name);
                        }
                    });
                    this.show1 = true;
                    this.$q.loading.hide();
                }).catch(() => {
                    this.$q.loading.hide();
                });
        },
        submitFunction(allTrue) {
            this.$q.loading.show({
                message: 'Loading...'
            });
            if (this.level1Completed == true && this.level2Completed == true && allTrue === true && this.selectedItems !== []) {
                this.startDate = this.startDate.replaceAll("-", "/");
                this.endDate = this.endDate.replaceAll("-", "/")
                var productsURL = this.api_url + "/amazon-ad/add_campaigns_to_ad_scheduler";
                this.$http
                    .post(productsURL, this.submitData())
                    .then((response) => {
                        if (response.data) {
                            this.searchQuery = ''
                            this.selectAll = false
                            this.count = 1
                            this.timeFormat = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
                                this.timeFormatDisplay = ["", "", "", ""],
                                this.StepNumber = 1,
                                this.secondTableVisible = false,
                                this.campaignData = [],
                                this.campaign = {
                                },
                                this.selectedItems = [],
                                this.newBudget = ["50", "50", "50", "50"],
                                this.ruleName = "",
                                this.startDate = "",
                                this.endDate = "",
                                this.level1Completed = false,
                                this.level2Completed = false,
                                this.error1 = false,
                                this.error2 = false,
                                this.tick = [],
                                this.manualCampaign = false,
                                this.tickEnabled = [true, false, false, false],
                                this.budgetError = false,
                                this.budgetError1 = false,
                                this.secondTable.forEach(item => {
                                    item.selected = false;
                                });
                            this.firstTableCall()
                            this.$q.notify({
                                type: 'positive',
                                message: "Scheduler created Successfully",
                            })
                            this.$q.loading.hide();
                            this.disableSubmit = false;
                        }
                        else {
                            this.$q.notify({
                                type: 'negative',
                                message: "Scheduler not created",
                            })
                            this.$q.loading.hide();
                            this.disableSubmit = false;
                        }
                    }).catch(() => {
                        this.$q.loading.hide();
                    });
            }
            else {
                this.$q.notify({
                    type: 'negative',
                    message: "Please Fill all required columns",
                })
                this.disableSubmit = false;
                this.$q.loading.hide();
            }
        },
        suBmit() {
            this.$mixpanel.track('User Submitted in Adschedular',{
                info: 'user Submitted the form',

            });
            this.disableSubmit = true;
            var allTrue = this.tick.includes(true) && this.tick.every((value) => value === true || value === "" || value === " " || value === '');
            const trueCount = this.tick.reduce((count, value) => {
                return count + (value === true ? 1 : 0);
            }, 0);
            if (trueCount === 1 && allTrue === true) {
                this.$confirm('You have submitted only one time budget, for better result you need to create at least two timing. Are you sure to continue?', 'Warning!', 'warning')
                    .then(() => {
                        this.submitFunction(allTrue)
                    }).catch(() => {
                        // User clicked "Cancel" button
                        this.disableSubmit = false; // Set the disableSubmit flag to false
                    });
            }
            else if (allTrue === false && this.level1Completed == true && this.level2Completed == true) {
                this.$q.notify({
                    type: 'negative',
                    message: "Should Click 'Set' to save data",
                })
                this.disableSubmit = false;
            }
            else {
                this.submitFunction(allTrue)
            }
        },
        nextButton1() {
            if (this.ruleName == "" || this.startDate == "") {
                this.error1 = true;
            }
            else if (new Date(this.startDate) > new Date(this.endDate)) {
                this.error2 = true;
            }
            else {
                this.level1Completed = true;
                this.StepNumber = 2;
                this.error1 = false;
                this.error2 = false;
            }
        },
        nextButton2() {
            if (this.selectedItems.length == 0) {
                this.error2 = true;
            }
            else {
                this.level2Completed = true;
                this.StepNumber = 3;
                this.error2 = false;
            }
        },
        isTickSet(index) {
            return this.tickEnabled[index];
        },
        cancel() {
            this.show1 = false;
        },
        saveBackend(item) {
            var dataArray = [];
            for (var i = 0; i < item.length; i++) {
                if (item[i].is_enable == true) {
                    var status = "yes"
                }
                else {
                    var status = "no"
                }
                var data = {
                    time_to_occur: item[i].time_to_occur,
                    budget_setting: {
                        new_value: item[i].budget_setting.new_value
                    },
                    ad_scheduler_id: (item[i].ad_scheduler_id).toString(),
                    camp_name: item[i].camp_name,
                    is_enable: status
                };
                dataArray.push(data);
            }
            return dataArray
            // Perform save operation
            // You can emit an event with the edited data to the parent component or perform an API request to save the data
        },
        validateBudgetSettings() {
      return this.editDataTable.every(
        (item) => parseInt(item.budget_setting.new_value) >= 50 && parseInt(item.budget_setting.new_value) <= 5000
      );
    },
        save(item) {
            this.editDataTable = item;
            if(this.validateBudgetSettings(item)){
            this.level2Completed = false
            this.$q.loading.show({
                message: 'Loading...'
            });
            this.show1 = false;
            var productsURL = this.api_url + "/amazon-ad/update_edited_rules_scheduler";
            this.$http
                .post(productsURL, this.saveBackend(item))
                .then((response) => {
                    if (response.data.length === 0) {
                        this.firstTableCall()
                        this.$q.notify({
                            type: 'positive',
                            message: "Saved successfully",
                        })
                        this.searchQuery = ''
                        this.selectAll = false
                    }
                    else {
                        this.$q.notify({
                            type: 'negative',
                            message: "Not Saved ",
                        })
                        this.$q.loading.hide();
                    }
                }).catch(() => {
                    this.$q.loading.hide();
                });
        }
        else{
            this.$q.notify({
                            type: 'negative',
                            message: "*Invalid budget range specified. Please ensure that the budget is between 50 and 5000.",
                        })
        }
    }
    }
}
</script>